module.exports = __webpack_public_path__ + "img/recolumn_example4.1d7077b5.png";